// import React, { useEffect, useState } from "react";
// import { Applogo, profileLogo } from "../../../Routes/ImagePath";
// import { DatePicker } from "antd";
// import { Radio } from "react-feather";
// import { useNavigate } from "react-router-dom";
// import { Api_Url } from "../../../config/config";
// import axios from "axios";

// export const LeadsModalPopup = () => {
//   const initialTableData = [
//     {
//       module: "Projects",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Tasks",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Chat",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Estimates",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Invoices",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Timing Sheets",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//   ];

//   const [tableData, setTableData] = useState(initialTableData)

//   const AllFileLoginData = async () => {
//     try {
//       const id = JSON.parse(sessionStorage.getItem('user'))?.id
//       console.log("id", id)
//       const response = await axios.get(`${Api_Url}api/v1/FileLogin/${id}`, {
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       console.log("response", response)
//     } catch (error) {
//       return error
//     }
//   }

//   useEffect(() => {
//     AllFileLoginData()
//   }, [])

//   const [radioValue, setRadioValue] = useState(false);

//   // const [location, setLocation] = useState(null);

//   const [LocalFormData, setLocalFormData] = useState({
//     branchId: "",
//     sourceId: "",
//     firstName: "",
//     lastName: "",
//     mobile: "",
//     isCustomerIntrested: false,
//     expectedLoginDate: new Date(),
//     latitude: "",
//     longitude: "",
//   });

//   const handleRadioChange = (e) => {
//     setRadioValue(e.target.value === 'true');

//   };

//   const handleDateChange = (date) => {
//     setLocalFormData({ ...LocalFormData, VisitDate: date });
//   };

//   useEffect(() => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(function (position) {

//         const { latitude, longitude } = position.coords;
//         setLocalFormData({ ...LocalFormData, Latitude: latitude, Longitude: longitude });
//       });
//     } else {
//       console.log("Geolocation is not supported by this browser.");
//     }
//   }, [])

//   // console.log("location",location?.latitude)

//   const handleCheckboxChange = (module, column) => {
//     // Create a copy of the tableData
//     const updatedTableData = [...tableData];

//     // Find the row with the specified module
//     const row = updatedTableData.find((item) => item.module === module);

//     // Toggle the checkbox value
//     row[column] = !row[column];

//     // Set the updated data
//     setTableData(updatedTableData);
//   };

//   const HandleSubmit = () => {
//     console.log(LocalFormData)
//   }

//   const [allbranch, setAllBranch] = useState('')

//   const AllBranchName = async () => {
//     try {
//       const response = await axios.get(`${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`)
//       // console.log("response",response.data.data)
//       setAllBranch(response.data.data)
//     } catch (error) {
//       console.log("object", error)
//     }
//   }
//   console.log(allbranch)

//   useEffect(() => {
//     AllBranchName()
//   }, [])

//   return (
//     <>
//       <div id="add_client" className="modal custom-modal fade" role="dialog">
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">File Login</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="profile-image text-center mt-4 mb-4">
//                 <img
//                   // src={{Applogo} ? {Applogo} : {profileLogo}}
//                   src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYP-KKtRJXm9qK7k2_PA1utxbxWdpzGIdulQ&s'
//                   alt='mohit'
//                   className="img-fluid rounded-circle"
//                   style={{ width: '100px', height: '100px' }}
//                 />
//               </div>

//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Branch <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.BranchId}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, BranchId: e.target.value })}
//                       >
//                         <option value="">Select Branch</option>
//                         {allbranch && allbranch.length > 0 && allbranch.map((res) => (
//                           <option value={res.id}>{res.name}</option>
//                         ))}
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Source ID <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.BranchId}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, BranchId: e.target.value })}
//                       >
//                         <option value="">Select Branch</option>
//                         <option value="branch1">Hello</option>
//                         <option value="branch2">Branch 1</option>
//                         <option value="branch3">branch 2</option>
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">First Name <span className="text-danger">*</span></label>
//                       <input className="form-control" type="text" value={LocalFormData.Name} onChange={(e) => setLocalFormData({ ...LocalFormData, Name: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Last Name <span className="text-danger">*</span></label>
//                       <input className="form-control" type="text" value={LocalFormData.Name} onChange={(e) => setLocalFormData({ ...LocalFormData, Name: e.target.value })} />
//                     </div>
//                   </div>
//                   <div class="form-check form-switch">
//                     <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked" checked
//                       value={LocalFormData.isCustomerIntrested}
//                       onChange={(e) => setLocalFormData({ ...LocalFormData, isCustomerIntrested: e.target.checked })}
//                     />
//                     <label class="form-check-label" for="flexSwitchCheckChecked"
//                     >Customer Interest</label>
//                   </div>
//                 </div>
//                 {LocalFormData.isCustomerInterested && (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">Expected Date <span className="text-danger">*</span></label>
//                         <input
//                           className="form-control"
//                           type="date"
//                           value={LocalFormData.expectedLoginDate}
//                           onChange={(e) => setLocalFormData({ ...LocalFormData, expectedLoginDate: e.target.value })}
//                         />
//                       </div>
//                     </div>
//                   )}
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="button"
//                     onClick={HandleSubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>

//             </div>
//           </div>
//         </div>
//       </div>

//       <div id="edit_client" className="modal custom-modal fade" role="dialog">
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Edit Client</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         First Name <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         defaultValue="Barry"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Last Name</label>
//                       <input
//                         className="form-control"
//                         defaultValue="Cuda"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Username <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         defaultValue="barrycuda"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Email <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control floating"
//                         defaultValue="barrycuda@example.com"
//                         type="email"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Password</label>
//                       <input
//                         className="form-control"
//                         defaultValue="barrycuda"
//                         type="password"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Confirm Password</label>
//                       <input
//                         className="form-control"
//                         defaultValue="barrycuda"
//                         type="password"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Client ID <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control floating"
//                         defaultValue="CLT-0001"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Phone </label>
//                       <input
//                         className="form-control"
//                         defaultValue={9876543210}
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Company Name</label>
//                       <input
//                         className="form-control"
//                         type="text"
//                         defaultValue="Global Technologies"
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="table-responsive m-t-15">
//                   <table className="table table-striped custom-table">
//                     <thead>
//                       <tr>
//                         <th>Module Permission</th>
//                         <th className="text-center">Read</th>
//                         <th className="text-center">Write</th>
//                         <th className="text-center">Create</th>
//                         <th className="text-center">Delete</th>
//                         <th className="text-center">Import</th>
//                         <th className="text-center">Export</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {tableData.map((row, index) => (
//                         <tr key={index}>
//                           <td>{row.module}</td>
//                           {[
//                             "read",
//                             "write",
//                             "create",
//                             "delete",
//                             "import",
//                             "export",
//                           ].map((column) => (
//                             <td key={column} className="text-center">
//                               <label className="custom_check">
//                                 <input
//                                   type="checkbox"
//                                   checked={row[column]}
//                                   onChange={() =>
//                                     handleCheckboxChange(row.module, column)
//                                   }
//                                 />
//                                 <span className="checkmark"></span>
//                               </label>
//                             </td>
//                           ))}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="reset"
//                   >
//                     Save
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// HelpFull Code

import React, { useEffect, useState } from "react";
import axios from "axios";
import { Api_Url } from "../../../config/config";
import { ErrorToast, SuccessToast } from "../../ToastComponent";
import { Modal } from "antd";
import { AllFormsUpperphoto } from "../../../Routes/ImagePath";

export const LeadsModalPopup = ({ LeadsFetchFunctionData, onClose }) => {
  const initialTableData = [
    // Initial table data as defined earlier
  ];

  const [tableData, setTableData] = useState(initialTableData);
  const [loading, setLoading] = useState(false); // State for loading indicator
  const [allBranch, setAllBranch] = useState([]);
  const [productData, setProductData] = useState([]);
  const [LocalFormData, setLocalFormData] = useState({
    branchId: "",
    sourceId: "",
    productId: "",
    firstName: "",
    lastName: "",
    mobile: "",
    isCustomerInterested: false,
    expectedLoginDate: "",
    latitude: "",
    longitude: "",
  });

  const datastatus = [
    { id: 1, label: "Self Sourcing", value: "Self Sourcing" },
    { id: 2, label: "Existing Customer", value: "Existing Customer" },
    { id: 3, label: "Connector", value: "Connector" },
    { id: 4, label: "Marketing Activity", value: "Marketing Activity" },
    { id: 5, label: "Digital Marketing", value: "Digital Marketing" },
    { id: 6, label: "Other Channel Partner", value: "Other Channel Partner" },
  ];

  useEffect(() => {
    // Fetch branch data
    const fetchBranches = async () => {
      try {
        const response = await axios.get(
          `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,
          {
            headers: {
              Authorization: `Bearer ${
                JSON.parse(sessionStorage.getItem("user")).accessToken
              }`,
            },
          }
        );
        setAllBranch(response.data.data);
      } catch (error) {
        console.log("Error fetching branches", error);
      }
    };

    fetchBranches();
  }, []);

  useEffect(() => {
    // Fetch product data
    const fetchProducts = async () => {
      try {
        const response = await axios.get(
          `${Api_Url}api/v1/Product?PageNumber=1&PageSize=20`,
          {
            headers: {
              Authorization: `Bearer ${
                JSON.parse(sessionStorage.getItem("user")).accessToken
              }`,
            },
          }
        );
        setProductData(response.data.data);
      } catch (error) {
        console.log("Error fetching products", error);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    // Get geolocation
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocalFormData((prevData) => ({
            ...prevData,
            latitude: `${latitude}`,
            longitude: `${longitude}`,
          }));
        },
        (error) => {
          console.error("Error getting geolocation:", error);
        }
      );
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setLocalFormData({ ...LocalFormData, mobile: value });
    }
  };

  const validateForm = () => {
    const {
      branchId,
      sourceId,
      productId,
      firstName,
      lastName,
      mobile,
      expectedLoginDate,
      isCustomerInterested,
    } = LocalFormData;

    if (
      !branchId ||
      !sourceId ||
      !productId ||
      !firstName ||
      !lastName ||
      mobile.length !== 10
    ) {
      ErrorToast("Please fill all required fields correctly.Mobile Number Must be 10 digit");
      return false;
    }

    if (isCustomerInterested && !expectedLoginDate) {
      ErrorToast(
        "Expected Date is required when Customer Interest is selected."
      );
      return false;
    }

    return true;
  };

  const HandleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!validateForm()) {
      setLoading(false);
      return;
    }

    const formatDateToUTC = (dateString) => {
      const date = new Date(dateString);
      return date.toISOString(); // Simplified UTC date formatting
    };

    const filteredData = {
      ...LocalFormData,
      expectedLoginDate: LocalFormData.isCustomerInterested
        ? formatDateToUTC(LocalFormData.expectedLoginDate)
        : null,
    };

    try {
      await axios.post(`${Api_Url}api/v1/Lead`, filteredData, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      });

      LeadsFetchFunctionData();
      resetForm();
      SuccessToast("Leads Submitted Successfully");
      onClose();
    } catch (error) {
      ErrorToast("Something went wrong");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setLocalFormData({
      branchId: "",
      sourceId: "",
      productId: "",
      firstName: "",
      lastName: "",
      mobile: "",
      isCustomerInterested: false,
      expectedLoginDate: "",
      latitude: "",
      longitude: "",
    });
  };

  return (
    <Modal
      title={<h4>Add Leads</h4>}
      open={true}
      onOk={onClose}
      onCancel={onClose}
      footer={[
        <div
          className="d-flex justify-content-between align-items-center"
          key="footer"
        >
          <button
            className="btn btn-danger submit-btn"
            type="button"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary submit-btn"
            type="submit"
            onClick={HandleSubmit}
            disabled={loading} // Disable button when loading
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>,
      ]}
      width={600}
      mask={false}
      maskClosable={false}
      closeIcon={<span style={{ color: "red" }}>X</span>}
    >
      <div className="modal-body mt-5">
        <div className="profile-image text-center mt-4 mb-4">
          <img
            src={AllFormsUpperphoto}
            alt="Profile"
            className="img-fluid rounded-circle"
            style={{ width: "100px", height: "100px" }}
          />
        </div>
        <form>
          <div className="row">
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Branch <span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  value={LocalFormData.branchId}
                  onChange={(e) =>
                    setLocalFormData({
                      ...LocalFormData,
                      branchId: e.target.value,
                    })
                  }
                  required
                >
                  <option value="">Select Branch</option>
                  {allBranch.map((branch) => (
                    <option key={branch.id} value={branch.id}>
                      {branch.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Product <span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  value={LocalFormData.productId}
                  onChange={(e) =>
                    setLocalFormData({
                      ...LocalFormData,
                      productId: e.target.value,
                    })
                  }
                  required
                >
                  <option value="">Select Product</option>
                  {productData.map((product) => (
                    <option key={product.id} value={product.id}>
                      {product.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  First Name <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  value={LocalFormData.firstName}
                  onChange={(e) =>
                    setLocalFormData({
                      ...LocalFormData,
                      firstName: e.target.value,
                    })
                  }
                  required
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Last Name <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  value={LocalFormData.lastName}
                  onChange={(e) =>
                    setLocalFormData({
                      ...LocalFormData,
                      lastName: e.target.value,
                    })
                  }
                  required
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Mobile <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  value={LocalFormData.mobile}
                  onChange={handleMobileChange}
                  required
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Source ID <span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  value={LocalFormData.sourceId}
                  onChange={(e) =>
                    setLocalFormData({
                      ...LocalFormData,
                      sourceId: e.target.value,
                    })
                  }
                  required
                >
                  <option value="">Select Source</option>
                  {datastatus.map((status) => (
                    <option key={status.id} value={status.id}>
                      {status.value}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="form-check form-switch mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="flexSwitchCheckChecked"
                checked={LocalFormData.isCustomerInterested}
                onChange={(e) =>
                  setLocalFormData({
                    ...LocalFormData,
                    isCustomerInterested: e.target.checked,
                  })
                }
              />
              <label
                className="form-check-label"
                htmlFor="flexSwitchCheckChecked"
              >
                Customer Interest
              </label>
            </div>
            {LocalFormData.isCustomerInterested && (
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Expected Date <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="date"
                    value={LocalFormData.expectedLoginDate}
                    onChange={(e) =>
                      setLocalFormData({
                        ...LocalFormData,
                        expectedLoginDate: e.target.value,
                      })
                    }
                    required={LocalFormData.isCustomerInterested}
                  />
                </div>
              </div>
            )}
          </div>
        </form>
      </div>
    </Modal>
  );
};
